'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25(evaluator$16) {
  this.Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25__f_evaluator$7 = null;
  this.Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25__f_evaluator$7 = evaluator$16;
}
export { $c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25 as $c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25 };
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25.prototype.constructor = $c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25;
/** @constructor */
function $h_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25() {
}
export { $h_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25 as $h_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25 };
$h_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25.prototype = $c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25.prototype;
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25.prototype.apply__s_Option = (function() {
  var v = this.Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25__f_evaluator$7.apply__O();
  return (((typeof v) === "string") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25, "app.data.AcceptedRequestProvidedEPSCode$Provided$$anon$25", ({
  Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25 as $d_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$$anon$25 };
//# sourceMappingURL=app.data.-Accepted-Request-Provided-E-P-S-Code$-Provided$$anon$25.js.map
